import { RouteView, PageView } from '../layouts'
export const qa = {
  path: '/operation/qandA',
  name: 'BaseForm',
  component: PageView,
  meta: { title: '问答管理', icon: 'form', isMenuShow: true, permission: 'qa' },
  children: [
    {
      path: '/operation/qandA',
      name: 'integral',
      component: () => import('../views/operation/qandA/list'),
      meta: { title: '用车指南', icon: 'skin', isMenuShow: true, permission: 'qa:guid:list' },
      children: [
        {
          path: '/operation/qandA/list',
          name: 'QandAlist',
          component: () => import('../views/operation/qandA/list.vue'),
          meta: { title: '用车指南', icon: 'dollar', isMenuShow: true, permission: 'qa:guid:list' },
        },
      ]
    },
    {
      path: '/operation/qandA/create',
      name: 'create',
      component: () => import('../views/operation/qandA/createNote'),
      meta: { title: '创建指南', icon: 'skin', permission: 'qa:guid:create' },
    },
    {
      path: '/operation/qandA/categoryList',
      name: 'categoryList',
      component: () => import('../views/operation/qandA/categoryList'),
      meta: { title: '分类管理', isMenuShow: true, permission: 'qa:category' },
    },
    {
      path: '/operation/qandA/labelList',
      name: 'labelList',
      component: () => import('../views/operation/qandA/labelList'),
      meta: { title: '标签管理', isMenuShow: true, permission: 'qa:label' },
    },
    {
      path: '/operation/qandA/anwserList',
      name: 'anwserList',
      component: () => import('../views/operation/qandA/anwserList'),
      meta: { title: '问答列表', isMenuShow: true, permission: 'qa:answer:list' },
    },
    {
      path: '/operation/qandA/anwserCreate',
      name: 'anwserCreate',
      component: () => import('../views/operation/qandA/anwserCreate'),
      meta: { title: '创建问答', isMenuShow: false, permission: 'qa:answer:create' },
    },
  ]
}
